import { externalLinks } from "assets/external-links/external-links";
import LocalImages from "assets/images/local-images";
import Content, { ContentNS } from "content/content";
import LocalePicker from "features/layout/components/locale-picker/LocalePicker";
import useHeaderLinks from "features/shared/hooks/navigation/useHeaderLinks";
import Container from "features/shared/styles/container/Container.styled";
import NativeBridge from "services/native-bridge/native-bridge";

import BurgerMenu from "./components/BurgerMenu";
import CloseButton from "./styles/CloseButton.styled";
import HeaderActions from "./styles/HeaderActions.styled";
import HeaderStart from "./styles/HeaderStart.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import HeaderLink from "./styles/HeaderLink-APP_CLIENT.styled";
import HeaderLinks from "./styles/HeaderLinks.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import StyledHeader from "./styles/StyledHeader-APP_CLIENT.styled";
import StyledHeaderContent from "./styles/StyledHeaderContent.styled";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";

const Header = () => {
  const images = LocalImages.shared.images;
  const links = useHeaderLinks(false);
  const textUI = (s: string) => Content.shared.t(s, { ns: ContentNS.ui });

  return (
    <StyledHeader>
      <Container className="full-height">
        <StyledHeaderContent>
          <HeaderStart>
            {NativeBridge.shared.isEmbedded && (
              <CloseButton
                type="button"
                aria-label={textUI("button.close")}
                onClick={() => NativeBridge.shared.closeFlow("user_closed")}
              >
                <img alt="close" src={images.icons.burgerMenuClose} />
              </CloseButton>
            )}
            <a href={externalLinks.homePage}>
              <img
                alt="airline logo"
                className="airline-logo"
                src={images.airlineLogo}
              />
              <img
                alt="airline logo"
                className="airline-logo-mobile"
                src={images.airlineLogoMobile}
              />
            </a>
          </HeaderStart>
          <HeaderActions>
            <section className="header-links">
              <HeaderLinks>
                {links.map((link, index) => {
                  return (
                    <HeaderLink href={link.url} key={`header-link-${index}`}>
                      <ButtonTitle>{link.title}</ButtonTitle>
                    </HeaderLink>
                  );
                })}
              </HeaderLinks>
            </section>
            <div className="separator" />
            <LocalePicker />
            <BurgerMenu />
          </HeaderActions>
        </StyledHeaderContent>
      </Container>
    </StyledHeader>
  );
};

export default Header;
